export const cleanInputs = () => {
    document.getElementById('user_full_name').value = '';
    document.getElementById('user_login').value = '';
    document.getElementById('user_password').value = '';
}

export const buildCreateSellerBody = (company) => {
    return {
        full_name: document.getElementById('user_full_name').value,
        login: document.getElementById('user_login').value,
        password: document.getElementById('user_password').value,
        rol: document.getElementById('user_rol').value,
        company
    }
}

export const validateCreateSeller = (body) => {

    if(body.full_name === null || body.full_name === ''){
        throw new Error('Nombre vacío');
    }

    if(body.login === null || body.login === ''){
        throw new Error('Usuario vacío');
    }

    if(body.rol === null || body.rol === ''){
        throw new Error('Rol vacío');
    }

    if(body.password === null || body.password === ''){
        throw new Error('Constraseña vacía');
    }
}

export const validateEditSeller = (body) => {

    if(body.full_name === null || body.full_name === ''){
        throw new Error('Nombre vacío');
    }

    if(body.login === null || body.login === ''){
        throw new Error('Usuario vacío');
    }

    if(body.rol === null || body.rol === ''){
        throw new Error('Rol vacío');
    }
}